import { validateError } from "@/utils/validation";

export const SMS_RESUBSCRIBE_REQUIRED_CODE = "sms_resubscribe_required";

export const getSmsResubscribeMessage = (error: unknown): string | undefined => {
  const apiError = validateError(error)?.response.data.error;

  return apiError?.code === SMS_RESUBSCRIBE_REQUIRED_CODE ? apiError.message : undefined;
};
